module.exports = __webpack_public_path__ + "img/huan.6dcd5d6b.png";